import styled from 'styled-components';

const UndoButtonStyle = styled.button`
  appearance: none;
  cursor: pointer;
  position: relative; // Added for positioning the loader
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  min-width: 30px;

  background: transparent;
  border: 0;
  border-left: 0px;
  color: var(--primary);
  padding: 0px 10px;
  svg {
    transform: scale(-1, 1);
  }
  @media (max-width: 860px) {
    height: 30px;
    padding-left: 6px;
    svg {
      width: 20px;
      height: 20px;
    }
  }

  &:disabled {
    cursor: not-allowed !important;
    opacity: 0.7;
  }
  &.strip {
    border-left: 1px solid var(--borderLightColor);
    &#undo-delete-obstruction{
    border-left: none;
    }

}
	&.no-left-border {
		border-left: 0px !important;
	}
`;

export { UndoButtonStyle };
